import React from 'react';

import { CliveAvatar } from '~/components/Clive/CliveAvatar';
import Text from '~/components/core/TextComponents/Text';

import { EMBEDDED_CHAT_CONFIG } from '../constants';

export const EmbeddedChatHeaderLogo: React.FC = () => {
  return (
    <div className="flex items-center gap-8">
      <CliveAvatar mood={CliveAvatar.MOOD.HAPPY} size={EMBEDDED_CHAT_CONFIG.iconSize.logo} />
      <Text variant={Text.VARIANTS.SM} weight={Text.WEIGHTS.SEMI_BOLD} className="text-blue-900">
        Clive
      </Text>
    </div>
  );
};
